import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { useCanEditWorkspace } from '@/hooks/useCanEditWorkspace'
import { useStytchWorkspaceMembers } from '@/hooks/useStytchWorkspaceMembers'
import { setIsInviteUsersDialogOpen } from '@/redux/store/slices/ui/uiSlice'
import { useAppDispatch } from '@redux/hooks/useAppState'
import { PlusIcon } from 'lucide-react'

import { UserList } from './UserList/UserList'

export const Users = () => {
	const dispatch = useAppDispatch()
	const canEdit = useCanEditWorkspace()
	const { members, isLoading } = useStytchWorkspaceMembers()

	return (
		<div className="p-6">
			<Card>
				<CardHeader>
					<div className="flex items-center justify-between">
						<div className="space-y-1.5">
							<CardTitle>Users</CardTitle>
							<CardDescription>
								Manage user access and permissions for your workspace
							</CardDescription>
						</div>
						{canEdit && (
							<Button
								size="sm"
								className="cursor-pointer"
								onClick={() => dispatch(setIsInviteUsersDialogOpen(true))}
							>
								<PlusIcon className="h-4 w-4 mr-2" />
								Invite User
							</Button>
						)}
					</div>
				</CardHeader>
				<CardContent>
					<UserList members={members} isLoading={isLoading} />
				</CardContent>
			</Card>
		</div>
	)
}
